module.exports = __webpack_public_path__ + "static/5-c17a62b1ccbafd30c30215d10f87cd92.jpg";